var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.0194 128)",
    className: "st0",
    cx: 128,
    cy: 128,
    rx: 120,
    ry: 120
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 60.9,
    y1: 85.7,
    x2: 86.9,
    y2: 111.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 86.9,
    y1: 85.7,
    x2: 60.9,
    y2: 111.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 169.1,
    y1: 85.7,
    x2: 195.1,
    y2: 111.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 195.1,
    y1: 85.7,
    x2: 169.1,
    y2: 111.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.2,167.7c-1.9,6.2-7.7,10.5-14.5,10.5c-7,0-12.9-4.7-14.6-11.1l0,0c-2.1-5.9-7.7-10.1-14.3-10.1 c-6.9,0-12.7,4.5-14.5,10.8c-1.9,6.2-7.7,10.5-14.5,10.5c-7,0-12.9-4.7-14.6-11.1c-2.1-5.8-7.7-10.1-14.3-10.1 c-6.9,0-12.7,4.5-14.5,10.8c-1.9,6.2-7.7,10.5-14.5,10.5c-7,0-12.9-4.7-14.6-11.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScared);
export default __webpack_public_path__ + "static/media/Scared.74030066054375539faff17753ae985a.svg";
export { ForwardRef as ReactComponent };